import { render, staticRenderFns } from "./KMenuWithChildren.vue?vue&type=template&id=562bc5d6"
import script from "./KMenuWithChildren.vue?vue&type=script&lang=js"
export * from "./KMenuWithChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports